/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BehavioralAssessmentCto } from '../../models/behavioral-assessment-cto';

export interface GetDeletedBehavioralAssessments$Plain$Params {
  folderId: number;
}

export function getDeletedBehavioralAssessments$Plain(http: HttpClient, rootUrl: string, params: GetDeletedBehavioralAssessments$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BehavioralAssessmentCto>>> {
  const rb = new RequestBuilder(rootUrl, getDeletedBehavioralAssessments$Plain.PATH, 'get');
  if (params) {
    rb.path('folderId', params.folderId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BehavioralAssessmentCto>>;
    })
  );
}

getDeletedBehavioralAssessments$Plain.PATH = '/behavioralAssessment/{folderId}';
